import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Music, RefreshCw } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/creatives`;

export const MusicDialog = ({ asset, onClose, onStarted }) => {
  const [style, setStyle] = useState("");
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const reqId = useRef(0);
  const suggest = () => {
    const id = ++reqId.current;
    setLoading(true);
    axios.post(`${API}/${asset.id}/music/suggest`)
      .then((r) => { if (id === reqId.current) setStyle(r.data.style); })
      .catch((e) => { if (id === reqId.current) toast.error(e.response?.data?.detail || e.message); })
      .finally(() => { if (id === reqId.current) setLoading(false); });
  };
  useEffect(suggest, [asset.id]);

  const go = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/${asset.id}/music`, { style });
      toast.success("Compun muzica — video-ul cu sunet apare în ~1–2 minute");
      onStarted(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="music-dialog" className="max-w-md">
        <DialogHeader><DialogTitle>Adaugă muzică pe video</DialogTitle></DialogHeader>
        <p className="text-xs text-zinc-500">Muzică instrumentală originală compusă de AI (ElevenLabs), fără probleme de drepturi. Video-ul original rămâne și el în galerie. Cost ~$0.05–0.10.</p>
        <div className="relative">
          <Textarea data-testid="music-style-input" value={style} onChange={(e) => setStyle(e.target.value)} rows={3} disabled={loading} className="pb-9 pr-10"
            placeholder={loading ? "AI-ul alege stilul potrivit produsului…" : "ex. upbeat electronic pop, energetic, 120 bpm"} />
          <button data-testid="music-resuggest-btn" onClick={suggest} disabled={loading} title="Alt stil propus de AI" className="absolute bottom-2 right-2 rounded-full bg-zinc-100 p-1.5 text-zinc-600 hover:text-amber-600">
            {loading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5" />}
          </button>
        </div>
        <button data-testid="music-generate-btn" onClick={go} disabled={busy || loading || !style.trim()} className="flex items-center justify-center gap-2 rounded-full bg-amber-400 py-2.5 text-sm font-semibold text-zinc-950 disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Music className="h-4 w-4" />} Compune și adaugă muzica
        </button>
      </DialogContent>
    </Dialog>
  );
};
